var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetModem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 12.4161V14.7639C14.3863 15.3133 14 16.1115 14 17C14 18.6569 15.3431 20 17 20C18.6569 20 20 18.6569 20 17C20 16.1115 19.6138 15.3133 19.0001 14.7639V12.4161C20.766 13.1876 22 14.9497 22 17C22 19.7614 19.7614 22 17 22C14.2386 22 12 19.7614 12 17C12 14.9497 13.2341 13.1876 15 12.4161ZM9.99998 3V9.99998H8.00002L7.99988 6.25477C6.18647 7.51973 5.00002 9.62133 5.00002 12C5.00002 15.6401 7.77848 18.6313 11.3303 18.9683C11.5911 19.7197 11.9971 20.4032 12.5148 20.9855C12.3444 20.9952 12.1728 21 12 21C7.02942 21 3 16.9706 3 12C3 9.17269 4.30373 6.64988 6.3428 4.99992L3 5.00002V3H9.99998ZM18 11V17H16V11H18ZM13.1165 3.06858C17.5602 3.61842 21 7.40747 21 12C21 12.1728 20.9951 12.3444 20.9853 12.5147C20.4032 11.9971 19.7197 11.5911 18.9684 11.3303C18.6585 8.06541 16.1061 5.45391 12.8684 5.05331L13.1165 3.06858Z",
    fill: "#264C86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetModem);
export default __webpack_public_path__ + "static/media/reset_modem.dba70cf5abd0ad260e6ff8e19ae931c7.svg";
export { ForwardRef as ReactComponent };